(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sc-sauna-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sc-sauna-options')) {
    class SCSaunaOptions extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        const init = () => {
          const form = this.closest('form');
          if (!form) return;
          const native = form.querySelector('[data-variant]');
          const controls = [...this.querySelectorAll('[data-sc-option]')];
          if (!native) { if (!controls.length) { this.hidden = false; this.dataset.ready = '1'; } return; }
          const choices = [...native.options].map(option => ({ element: option, id: option.value, cents: Number(option.dataset.priceCents), values: [0,1,2].map(index => option.hasAttribute(`data-option-${index}`) ? Number(option.getAttribute(`data-option-${index}`)) : null) }));
          const initial = choices.find(choice => choice.id === native.value);
          if (!initial || !choices.length || choices.some(choice => !Number.isFinite(choice.cents)) || controls.some(control => choices.some(choice => choice.values[Number(control.dataset.scOption)] === null))) return;
          const selected = [...initial.values];
          controls.forEach(control => { const value = selected[Number(control.dataset.scOption)]; if (control.type === 'checkbox') control.checked = value === Number(control.dataset.on); else control.value = String(value); });
          const match = values => choices.find(choice => choice.values.every((value, index) => value === values[index]));
          const formatter = new Intl.NumberFormat(this.dataset.locale || 'sv', { style: 'currency', currency: this.dataset.currency || 'SEK', maximumFractionDigits: 2 });
          const surcharge = cents => cents > 0 ? ` (+${formatter.format(cents / 100)})` : '';
          const unavailable = this.querySelector('[data-sc-unavailable]');
          const buy = form.querySelector('button[type="submit"]');
          const sync = () => {
            controls.forEach(control => { selected[Number(control.dataset.scOption)] = control.type === 'checkbox' ? Number(control.checked ? control.dataset.on : control.dataset.off) : Number(control.value); });
            const choice = match(selected);
            if (!choice) { buy.disabled = true; unavailable.hidden = false; return; }
            native.value = choice.id;
            native.dispatchEvent(new Event('change', { bubbles: true }));
            unavailable.hidden = choice.element.dataset.available === 'true';
            controls.forEach(control => {
              const index = Number(control.dataset.scOption);
              const baseValues = [...selected]; baseValues[index] = 0;
              const baseline = match(baseValues);
              if (control.type === 'checkbox') {
                const addedValues = [...selected]; addedValues[index] = Number(control.dataset.on);
                const added = match(addedValues);
                control.disabled = !control.checked && (!added || added.element.dataset.available !== 'true');
                const price = control.closest('label').querySelector('[data-addon-price]');
                price.textContent = added && baseline ? surcharge(added.cents - baseline.cents).trim() : this.dataset.unavailable;
              } else {
                [...control.options].forEach(option => {
                  const values = [...selected]; values[index] = Number(option.value);
                  const candidate = match(values);
                  option.disabled = !candidate || candidate.element.dataset.available !== 'true';
                  option.textContent = option.dataset.label + (candidate && baseline ? surcharge(candidate.cents - baseline.cents) : '') + (!candidate || candidate.element.dataset.available !== 'true' ? ` · ${this.dataset.unavailable}` : '');
                });
              }
            });
            const heater = this.querySelector('[data-sc-heater]');
            const hint = this.querySelector('[data-heater-hint]');
            if (heater && hint) hint.textContent = heater.value === '0' ? hint.dataset.without : hint.dataset.with;
          };
          controls.forEach(control => control.addEventListener('change', sync));
          form.addEventListener('submit', event => { const choice = match(selected); if (!choice || choice.element.dataset.available !== 'true') { event.preventDefault(); unavailable.hidden = false; } });
          sync();
          this.dataset.ready = '1';
          this.hidden = false;
          const fallback = form.querySelector('[data-native-variant]');
          if (fallback) fallback.hidden = true;
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
      }
    }
    customElements.define('sc-sauna-options', SCSaunaOptions);
  }
  } catch(e) { console.error(e); }
})();

})();
